export default {
    obtenerAseguradoras(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerAseguradora`).then(response => {
            vm.aseguradoras = response.data;
            vm.filteredOptions = response.data;
        })
    },
    obtenerRelevancia(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerRelevancia`).then(response => {
            vm.relevancias = response.data;
        })
    },
    obtenerFlotillas(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerFlotilla`).then(response => {
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];
        })
    },
    async obtenerGerencias(vm) {
        await vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerGerencia`).then(response => {
            vm.gerencias = response.data;
        })
    },
    async obtenerSupervisorias(vm) {
        await vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerSupervisoria`).then(response => {
            vm.supervisorias = response.data;
            vm.supervisoriasTemp = [...vm.supervisorias];
        })
    },
    obtenerAbogados(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerAbogado`).then(response => {
            vm.abogados = response.data;
            vm.abogadosTemo = [...vm.abogados];
        })
    },
    obtenerEstados(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerEstado`).then(response => {
            vm.estados = response.data;
        })
    },
    obtenerProcesos(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerProceso`).then(response => {
            vm.procesos = response.data;
            /* TODO: Remover valor asignado en procesos cuando ya esten los otros procesos*/
            vm.busqueda.proceso = { ...vm.procesos[0] }
        })
    },
    obtenerFlotillasGD(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}Tablero/ObtenerFlotillaGD`).then(response => {
            vm.flotillas = response.data;
            vm.flotillasTemp = [...vm.flotillas];
        })
    },
}